
<!--【公共头部-、底部】 -->
<template>
  <div id="mob_layout">
    <GlobalHeaderMob />
    <div class="box90"></div>
      <router-view />
    <GlobalFooterMob />
  </div>
</template>

<script>
import GlobalHeaderMob from "./components/mob/GlobalHeader";
import GlobalFooterMob from "./components/mob/GlobalFooter";
export default {
  components: { GlobalHeaderMob, GlobalFooterMob }
};
</script>

<style>
@import "~@/assets/mob/css/public.scss";
</style>